import collect from 'collect.js';
import * as types from './mutation-types';
import { PMREMGenerator } from 'three';

export default {
    setup({ commit }, items) {
        if (items.camera) {
            commit(types.CAMERA, items.camera);
        }
        if (items.renderer) {
            commit(types.RENDERER, items.renderer);
            commit(types.PMREMGENERATOR, new PMREMGenerator(items.renderer));
        }
    },

    setEnvMap({ commit }, envMap) {
        commit(types.ENV_MAP, envMap);
    },

    setControls({ commit }, controls) {
        commit(types.CONTROLS, controls);
    },

    initLoader({ commit, state }) {
        state.loadingManager.onStart = (url, itemsLoaded, itemsTotal) => {
            // console.log(url, itemsLoaded, itemsTotal);
            commit(types.LOADED_ITEMS, itemsLoaded);
            commit(types.LOADED_TOTAL, itemsTotal);
            commit(types.LOAD_FINISHED, false);
        };
        state.loadingManager.onLoad = () => {
            // eslint-disable-next-line no-console
            console.log('load finished');
            commit(types.LOAD_FINISHED, true);
        };
        state.loadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
            //console.log(url, itemsLoaded, itemsTotal);
            commit(types.LOADED_ITEMS, itemsLoaded);
            commit(types.LOADED_TOTAL, itemsTotal);
        };
    },

    setLoadFinished({ commit }, loadFinished) {
        commit(types.LOAD_FINISHED, loadFinished);
    },

    loadHotspots({ commit, state }, payload) {
        if (payload.empty) {
            commit(types.HOTSPOTS, payload.hotspots);
        } else {
            const transformed = collect(payload.hotspots)
                .map(hotspot => {
                    return {
                        id: hotspot.name,
                        object: hotspot,
                        selected: false,
                        side: payload.side
                    };
                })
                .all();
            commit(types.HOTSPOTS, transformed.concat(state.hotspots));
        }
    },

    setHotspotTexture({ commit }, payload) {
        if (payload.type === 'selected') {
            commit(types.HOTSPOT_ON_TEXTURE, payload.texture);
        } else {
            commit(types.HOTSPOT_OFF_TEXTURE, payload.texture);
        }
    },

    setCurrentHotspot({ state, dispatch }, name) {
        // eslint-disable-next-line no-console
        console.log('setting hotspot to: ' + name);
        collect(state.hotspots).each(hotspotObj => {
            hotspotObj.selected = hotspotObj.id === name;
        });
        dispatch('setHotspotByStatus');
    },

    changeHotspotTextureMap({ state }, payload) {
        const map =
            payload.type === 'selected'
                ? state.hotspotOnTexture
                : state.hotspotOffTexture;
        collect(state.hotspots)
            .filter(hotspot => hotspot.id === payload.name)
            .each(hotspot => {
                hotspot.object.material.map = map;
                hotspot.object.material.needsUpdate = true;
            });
    },

    setHotspotByStatus({ state }) {
        collect(state.hotspots).each(hotspotObj => {
            const map = hotspotObj.selected
                ? state.hotspotOnTexture
                : state.hotspotOffTexture;

            hotspotObj.object.material.map = map;
            hotspotObj.object.material.needsUpdate = true;
        });
    },

    turnOffInactiveHotspots({ state }) {
        collect(state.hotspots).each(hotspotObj => {
            if (
                !hotspotObj.selected &&
                hotspotObj.object.material.map !== state.hotspotOffTexture
            ) {
                hotspotObj.object.material.map = state.hotspotOffTexture;
                hotspotObj.object.material.needsUpdate = true;
            }
        });
    }
};
